import React from 'react';

import { RiskTag } from '@/components/chariot-ui';
import { SEVERITY_TAG_MAP } from '@/sections/vulnerabilities/constants/severity';
import type { Asset } from '@/types';
import { RiskSeverity, SeverityDef } from '@/types';

interface AssetSeverityCellProps {
  asset: Asset;
}

const isKnownSeverity = (v: string | undefined): v is RiskSeverity =>
  v !== undefined && Object.prototype.hasOwnProperty.call(SeverityDef, v);

export const AssetSeverityCell: React.FC<AssetSeverityCellProps> = ({
  asset,
}) => {
  const code = asset.riskSeverity;
  if (!isKnownSeverity(code)) {
    return <span className="text-chariot-text-secondary">-</span>;
  }
  return <RiskTag severity={SEVERITY_TAG_MAP[code]} size="xs" />;
};
